import { css } from 'emotion'

export const CaretSquareDownIconStyles = css`
  transform: rotate(270deg);
`
